import { Icon } from '@iconify/react';
import { alpha, Box, Button, Container, Stack, styled, Typography } from '@mui/material';
import { m } from 'framer-motion';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MotionViewport, varFade } from '../../components/animate';
import Logo from '../../components/Logo';
import { PATH_PAGE } from '../../routes/paths';

const RootStyle = styled(Stack)(() => ({
  width: '100%',
  marginTop: 40,
  backgroundColor: alpha('#E3E4E6', 0.4),
}));

const ButtomStyle = styled(Button)(() => ({
  color: '#fff',
  borderRadius: 15,
  backgroundColor: '#000',
}));

export default function HomeHero2() {
  const navigate = useNavigate();

  return (
    <Stack width={1} position="relative">
      <RootStyle width={1} justifyContent="center" alignItems="center" py={10}>
        <Container>
          <Stack component={MotionViewport} direction={{ xs: 'column', md: 'row' }} alignItems="center" spacing={10}>
            <Stack
              component={m.div}
              variants={varFade().inLeft}
              width={1}
              height={1}
              justifyContent="center"
              alignItems="center"
            >
              <Stack height={1} borderRadius={2} bgcolor="#FFF">
                <Logo sx={{ objectFit: 'cover', height: 1, width: 1 }} />
              </Stack>
            </Stack>

            <Stack component={m.div} width={1} spacing={5} variants={varFade().inRight}>
              <Typography textAlign="justify">
                L'API-ZF, Agence de Promotion des Investissements et de la Zone Franche est une institution publique de
                l'Etat en charge des missions liées à l'attraction des Investisseurs et à la facilitation de leurs
                activités au Togo
              </Typography>
              <Typography textAlign="justify">
                Elle est chargée de la mise en oeuvre du code des Investissements en République Togolaise, du status de
                la Zone Franche industrielle et de tout autre régime économique spécial.
              </Typography>
              <Stack width={1} alignItems="flex-end">
                <ButtomStyle
                  sx={{ px: 2 }}
                  onClick={() => navigate(PATH_PAGE.accueil.presentation)}
                  endIcon={<Icon icon="ic:round-keyboard-arrow-right" />}
                >
                  EN SAVOIR PLUS
                </ButtomStyle>
              </Stack>
            </Stack>
          </Stack>
        </Container>
      </RootStyle>
      <Box
        component="img"
        position="absolute"
        right={0}
        top={0}
        src="/assets/background/geometric_form1.png"
        width={150}
        height={80}
      />
    </Stack>
  );
}
